import type { TranslationSchema } from './en'

export const fr: TranslationSchema = {
  game: {
    title: 'Path of Praxis',
    subtitle: 'Theorycrafte ton auto-battler incrémental',
    deathTitle: 'Vous êtes mort',
    deathSubtitle: 'Vous avez gagné l\'expérience et la maîtrise suivantes pour rendre votre prochaine renaissance plus forte :',
    deathRebirth: 'Renaissance',
    actionSelectTitle: 'Actions',
    triggersTitle: 'Déclencheurs',
    triggerAutoAction: 'Auto-attaque',
    actionPickerTitle: 'Choisir une action',
    legendDamage: 'Dégâts',
    legendSpeed: 'Vitesse',
    legendRange: 'Portée',
    legendArea: 'Zone',
    legendMana: 'Mana',
    targetingTitle: 'Priorité de ciblage',
    targetNearest: 'Plus proche',
    targetWeakest: 'Plus faible',
    targetStrongest: 'Plus fort',
    targetRandom: 'Aléatoire',
    targetNearestDesc: 'Attaquer l\'ennemi le plus proche',
    targetWeakestDesc: 'Cibler les PV bas',
    targetStrongestDesc: 'Cibler les PV élevés',
    targetRandomDesc: 'Choisir une cible au hasard',
    backToMenu: 'Retour au menu',
    dieRebirth: 'Mourir et renaître',
    freeRebirth: 'Renaissance gratuite',
    dieConfirmTitle: 'Mourir et renaître ?',
    dieConfirmBody: 'Votre partie en cours prendra fin et vos maîtrises seront appliquées. Continuer ?',
    dieConfirmYes: 'Mourir et renaître',
    battleConfig: 'Configuration de combat',
    masteries: 'Maîtrises',
    ascentBtnLabel: 'Ascension',
    enemyLevelLabel: 'Niveau d\'ennemi',
    pauseLabel: 'Pause',
    playLabel: 'Reprendre',
    x2SpeedRemaining: 'Temps restant ×2',
    enemyLevelDown: 'Diminuer le niveau ennemi',
    enemyLevelUp: 'Augmenter le niveau ennemi',
    autoAdvanceTitle: 'Avancer automatiquement le niveau ennemi au déverrouillage',
    autoLevelAriaLabel: 'Niveau automatique des ennemis',
    autoLevelText: 'Auto',
    ascendBtn: 'Ascendre vers un nouvel univers',
    masteryGains: 'Gains de maîtrise',
    actionTriggerTitle: 'Déclencheur d\'action',
    selectActionTrigger: 'Choisir un déclencheur',
    slotInUse: 'Déjà utilisé par un autre déclencheur',
    triggerTime: 'Déclencheur temporel',
    triggerTimeDesc: 'Se déclenche toutes les 2 secondes. Les actions plus rapides infligent plus de dégâts, les plus lentes en infligent moins.',
    triggerCrit: 'Déclencheur critique',
    triggerCritDesc: 'Se déclenche quand l\'auto-attaque atterrit un coup critique. Dégâts de base ×10 plus faibles, équilibrés par la vitesse.',
    triggerCritLock: 'Tuer un boss avec un coup critique',
    triggerAffliction: 'Déclencheur d\'affliction',
    triggerAfflictionDesc: 'Se déclenche tous les 10 afflictions appliquées. Dégâts équilibrés par la vitesse.',
    triggerAfflictionLock: 'Tuer un boss avec des dégâts d\'affliction',
    triggerMana: 'Déclencheur de mana',
    triggerManaDesc: 'Se déclenche tous les 100 points de mana dépensés par vos actions. Dégâts équilibrés par la vitesse.',
    dpsDoubleAction: 'Double action',
    dpsBonusTarget: 'Cible bonus',
    dpsExtraProjectile: 'Projectile supplémentaire',
    dpsSplitCast: 'Incantation divisée',
    dpsChainJump: 'Saut en chaîne',
    dpsTremor: 'Tremblement',
    dpsAfflictionBurn: 'Brûlure',
    dpsAfflictionBleed: 'Saignement',
    dpsAfflictionGroundFire: 'Feu au sol',
    dpsAfflictionPoison: 'Poison',
    dpsSplash: 'Éclaboussure',
    dpsTakenHits: 'Dégâts subis (coups)',
    dpsTakenAfflictions: 'Dégâts subis (afflictions)',
    dpsAvgHitTaken: 'Coup subi moyen',
    dpsMaxHitTaken: 'Plus gros coup subi',
    selectAnAction: 'Choisir une action',
    critLabel: 'Crit',
  },
  mastery: {
    title: 'Maîtrises',
    resetTitle: 'Réinitialiser {name} ?',
    confirmCancel: 'Annuler',
    confirmReset: 'Réinitialiser',
    resetDescLoseLevel: 'Tous les nœuds assignés seront effacés et vous perdrez 1 niveau dans cette maîtrise. Les points convertis sont remboursés.',
    resetDescNoLoseLevel: 'Tous les nœuds assignés seront effacés. Les points de maîtrise gratuits et convertis seront rendus.',
    nodeSmall: 'Nœud mineur',
    nodeStrong: 'Nœud solide',
    nodeMajor: 'Nœud majeur',
    nodeKey: 'Nœud clé',
    nodeAssigned: 'Assigné',
    nodeAssignPt: 'Assigner ({cost} pt)',
    nodeAssignPts: 'Assigner ({cost} pts)',
    nodeNeedPt: 'Besoin de {cost} point de maîtrise (vous en avez {available})',
    nodeNeedPts: 'Besoin de {cost} points de maîtrise (vous en avez {available})',
    nodeKeyChosen: 'Un autre nœud clé déjà choisi',
    nodeNotImpl: 'Pas encore implémenté',
    nodeNotAvail: 'Nœud non disponible',
    resetBtn: 'Réinitialiser (−1 niveau)',
    dumpBtn: 'Convertir un point',
    dumpTooltip: 'Clic : convertir 1 point · Ctrl/Cmd+clic : tout convertir',
    dumpActivePt: 'Conversion : {dumped} pt → +{bonus} % de {label} en plus',
    dumpActivePts: 'Conversion : {dumped} pts → +{bonus} % de {label} en plus',
    dumpLabel: 'Convertir des points pour +{rate} % de {label} en plus par point',
    pointsPt: 'Tu as {total} / {earned} point de maîtrise à assigner{free}',
    pointsPts: 'Tu as {total} / {earned} points de maîtrise à assigner{free}',
    pointsFree: ' ({n} gratuit)',
    ctrlClickHint: 'Astuce : Ctrl/Cmd + clic sur un nœud pour assigner tous les points possibles d’un coup.',
    savePlan: 'Sauvegarder le plan',
    loadPlan: 'Charger le plan',
    assignAll: 'Tout assigner',
    assignAllDump: 'Verser les points en trop',
    assignAllDumpTooltip: 'Tout assigner versera les points restants dans la conversion une fois le plan rempli',
    slot: 'Emplacement {n}',
    slotEmpty: '(vide)',
    copyClipboard: 'Copier dans le presse-papiers',
    importCode: 'Importer',
    planActive: '{code}',
    planInvalid: 'Code de build invalide',
    assignAllNone: 'Aucun plan chargé',
    saveNoHistory: 'L\'ordre d\'attribution de tes nœuds actuels n\'a pas été enregistré. La sauvegarde de plans se débloque après ta prochaine Ascension.',
    pendingGainsNote: 'La progression affichée en vert ne sera obtenue qu\'après être mort et renaître',
  },
  ascent: {
    title: 'Ascension',
    ascentCount: 'Nombre d\'ascensions : {n}',
    nextAscent: 'Prochaine ascension : niveau ennemi {n}',
    unlockedAt: 'Déverrouillé à',
    universePoints: 'Points d\'univers',
    available: '({n} disponible)',
    removePoint: 'Retirer un point',
    addPoint: 'Ajouter un point',
    threshold1: 'Coup critique et sa maîtrise',
    threshold2: 'Arbre Champions et Boss dans la maîtrise ennemie',
    threshold3: '+1 emplacement de déclencheur d\'action',
    threshold4: '+1 point de maîtrise gratuit par ascension pour chaque maîtrise',
    threshold5: 'Artefacts — modificateurs risque/récompense',
    threshold6: '+1 emplacement de déclencheur d\'action',
    threshold7: 'Chaque ascension accorde 3 points d\'univers au lieu de 2',
    threshold8: '20 % d\'ennemis en plus et 20 % d\'expérience de niveau d\'ennemi en plus',
    threshold9: 'Équipez un second artefact et transportez-en jusqu\'à 30 dans votre sac',
    artifactsBtn: 'Artefacts',
    upSlotA: 'Vitesse de multi-action augmentée de 10 %',
    upSlotB: '+1 % de chance de coup critique d\'action de base',
    upSlotC: '7 % de dégâts en plus',
    upSlotD: '4 % de vitesse d\'action en plus',
  },
  transcend: {
    btn: 'Transcender',
    pickerTitle: 'Choisissez une relique',
    pickerHint: 'Transcender réinitialise tout — y compris les ascensions, les points d\'univers et les artéfacts non équipés. Les artéfacts équipés et les reliques demeurent. Choisissez votre relique pour transcender.',
    confirmTitle: 'Transcender ?',
    confirmBody: 'Tout est réinitialisé — y compris les ascensions, les points d\'univers et les artéfacts non équipés. Les artéfacts équipés et les reliques demeurent.',
    relicFreeRebirth: 'Écho de renaissance',
    relicFreeRebirthDesc: 'Une fois par renaissance, gagnez votre progression de maîtrise non acquise sans mourir.',
    relicMultiAscend: 'Brise-chaînes',
    relicMultiAscendDesc: 'Ascendre peut accorder plusieurs ascensions à la fois, jusqu\'à votre niveau ennemi max −5.',
    relicExtraTrigger: 'Troisième main',
    relicExtraTriggerDesc: 'Débloque un emplacement de déclencheur d\'action supplémentaire permanent.',
    relicOnslaught: 'Déferlement',
    relicOnslaughtDesc: '30 % d\'ennemis en plus, 10 % d\'XP en plus, 10 % de dégâts en plus.',
    powerLabel: 'Transcendance : {n}',
    powerSummary: '+{xp} % XP · +{dmg} % dégâts · +{life} % vie max',
    relicsLabel: 'Reliques',
    ascendPlus: '{label} (+{n})',
  },
  artifacts: {
    title: 'Artefacts',
    countLabel: '{n}/{max} artefacts',
    equippedLabel: 'Équipés : {used}/{max}',
    full: 'Inventaire plein — déposez un artefact pour en recevoir de nouveaux des boss',
    equip: 'Équiper',
    unequip: 'Déséquiper',
    bag: 'Sac',
    drop: 'Déposer',
    deleteBtn: 'Supprimer',
    deleteConfirmTitle: 'Supprimer l\'artefact ?',
    deleteConfirmBody: 'Cet artefact sera définitivement perdu.',
    deleteConfirmBtn: 'Supprimer',
    lockedHint: 'Emplacements pleins — déséquipez un autre artefact d\'abord',
    sourceFire: 'feu',
    sourceLightning: 'foudre',
    sourcePhysical: 'physique',
    sourceCold: 'froid',
    sourceRot: 'pourriture',
    posSourceMoreDamage: '{v}% de dégâts de {source} en plus',
    posSourceActionSpeed: '{v}% de vitesse d\'action {source} augmentée',
    posSourceAffliction: '{v}% d\'effet d\'affliction {source} en plus',
    posGlobalActionSpeed: '{v}% de vitesse d\'action en plus',
    posGlobalMoreDamage: '{v}% de dégâts en plus',
    posDoubleDamageChance: '+{v}% de chance de double dégâts',
    posDoubleActionChance: '+{v}% de chance de double action',
    posRangeAndArea: '+{v}% de portée et zone',
    negDamageTaken: '{v}% de dégâts reçus en plus',
    negAllResistances: '-{v}% de toutes les résistances',
    negLessMoveSpeed: '-{v}% de vitesse de déplacement',
    negLessActionSpeed: '-{v}% de vitesse d\'action',
    negLessRangeAndArea: '-{v}% de portée et zone',
    weightLight: 'Artéfact Léger',
    weightMedium: 'Artéfact Moyen',
    weightHeavy: 'Artéfact Lourd',
    scrapsLabel: 'Fragments : {n}',
    upgradeBtn: 'Améliorer {scraps}/{cost}',
    upgradeResultTitle: 'Artéfact amélioré',
    upgradeMaxedTitle: 'Amélioration maximale',
    upgradeMaxedBody: 'Chaque ligne de cet artéfact est déjà à son maximum — il ne peut plus être amélioré.',
    upgradeRemovedLabel: 'Ligne négative supprimée :',
    autoDiscardLabel: "Rejeter automatiquement les artéfacts selon la qualité :",
    autoDiscardNever: 'ne jamais rejeter',
    autoDiscardAll: 'tout rejeter',
    autoDiscardBelow: '<{v}%',
    autoDiscardDown: 'Abaisser le seuil de qualité de rejet automatique',
    autoDiscardUp: 'Augmenter le seuil de qualité de rejet automatique',
    autoDiscardWeightLabel: 'ou poids :',
    autoDiscardWeightAll: 'garder toutes les tailles',
    autoDiscardWeightLight: 'rejeter les légers',
    autoDiscardWeightMedium: 'rejeter moyens et moins',
    autoDiscardWeightDown: 'Abaisser le seuil de poids de rejet automatique',
    autoDiscardWeightUp: 'Augmenter le seuil de poids de rejet automatique',
  },
  rune: {
    addToSlot: 'Ajouter une rune {type} à l\'emplacement {n}',
    clickToChange: '{label} — cliquer pour changer',
    addRune: '+ Ajouter une rune',
    remove: 'Retirer « {label} »',
    runesTitle: 'Runes de {action}',
    runesAriaLabel: 'Runes',
    slotMinor: 'Mineur',
    slotMajor: 'Majeur',
    slotKey: 'Clé',
    slotSource: 'Source',
    levelHint: 'Action Nv. {level} — {unlocked}/7 emplacements déverrouillés — +{bonus} % XP',
    selectTitle: 'Rune {type} — Emplacement {n}',
  },
  menu: {
    continue: 'Continuer',
    characters: 'Personnages',
    about: 'À propos',
    nav: 'Menu principal',
  },
  about: {
    title: 'À propos de Path of Praxis',
    body: 'Un auto-battler incrémental par Aractis, inspiré des action RPG, des jeux incrémentaux à prestige multi-couches et des systèmes de récompense basés sur l\'usage. Ce jeu en phase précoce (bêta) vise à offrir une expérience riche de theorycrafting avec les mécaniques d\'un jeu semi-idle. Merci de partager tout rapport, retour ou demande sur le Discord lié dans les options. Pensez à consulter la TODO ci-dessous !',
    creditsTitle: 'Crédits',
    creditsAlpha: 'Merci à N4pkin pour la motivation et le test alpha.',
    creditsKenneyUi: 'Panneaux et boutons UI : **Kenney RPG UI Pack Extension** (CC0).',
    creditsKenneyDungeon: 'Tuiles et obstacles : **Kenney Tiny Dungeon** (CC0).',
    creditsLucide: 'Icônes : **Lucide** (licence ISC).',
    creditsFonts: 'Polices : **Cinzel** et **Crimson Pro** via Google Fonts (SIL OFL).',
    creditsClaude: 'Vibe codé avec **Claude** (Anthropic).',
    releaseNotes: 'Notes de version',
    releaseNotesTitle: 'Notes de version',
    todo: 'TODO',
    todoTitle: 'TODO',
    privacy: 'Confidentialité',
    privacyTitle: 'Politique de confidentialité',
    eula: 'CLUF',
    eulaTitle: 'Contrat de licence utilisateur final',
  },
  terms: {
    title: 'Avant de jouer',
    intro: 'Merci de consulter et d\'accepter les deux documents pour continuer.',
    privacyLabel: 'J\'ai lu et j\'accepte la {link}.',
    eulaLabel: 'J\'ai lu et j\'accepte le {link}.',
    privacyLink: 'Politique de confidentialité',
    eulaLink: 'Contrat de licence utilisateur final',
    privacyTitle: 'Politique de confidentialité',
    eulaTitle: 'Contrat de licence utilisateur final',
    continue: 'Continuer',
  },
  character: {
    newTitle: 'Nouveau personnage',
    loadTitle: 'Charger un personnage',
    nameLabel: 'Nom',
    namePlaceholder: 'Entrez un nom…',
    create: 'Créer',
    cancel: 'Annuler',
    current: 'Actuel',
    emptySlot: '— Vide —',
    newSlot: 'Nouveau',
    deleteLabel: 'Supprimer',
    nameTaken: 'Ce nom est déjà utilisé.',
    infoTitle: 'Personnage',
    statMaxLife: 'Vie max',
    statMaxMana: 'Mana max',
  },
  settings: {
    title: 'Paramètres',
    language: 'Langue',
    languageTitle: 'Langue',
    hotkeysTitle: 'Raccourcis clavier',
    langEn: 'Anglais',
    langFr: 'Français',
    langEs: 'Espagnol',
    langZh: 'Chinois simplifié',
    langRu: 'Russe',
    close: 'Fermer',
    guide: 'Guide',
    discord: 'Discord',
    soundVolume: 'Volume sonore',
    soundMuted: 'Couper le son',
    effectOpacity: 'Opacité des effets',
    effectDetail: 'Rendu des effets',
    showDamageNumbers: 'Afficher les dégâts',
    showDpsMeter: 'Compteur DPS',
    fullMastery: 'Maîtrise complète',
    zoomLabel: 'Zoom',
    fullscreen: 'Plein écran',
    confirmDeath: 'Confirmer avant la mort manuelle',
    resetTutorials: 'Réinitialiser les tutoriels',
    saveData: 'Données de sauvegarde',
    saveDataDesc: 'Copiez votre code de sauvegarde pour la sauvegarder ou la transférer vers un autre appareil, ou collez un code ci-dessous pour la restaurer. L’importation remplace tous les personnages actuels.',
    exportSave: 'Copier le code de sauvegarde',
    exportCopied: 'Copié !',
    importLabel: 'Coller un code de sauvegarde',
    importPlaceholder: 'Collez votre code de sauvegarde ici…',
    importBtn: 'Importer',
    importError: 'Code de sauvegarde invalide',
    importConfirmTitle: 'Remplacer tous les personnages ?',
    importConfirmBody: 'L’importation remplacera définitivement TOUS vos personnages existants par les données de sauvegarde. Cette action est irréversible.',
    importConfirmBtn: 'Remplacer',
    cancel: 'Annuler',
  },
  guide: {
    title: 'Guide',
    comingSoon: 'Bientôt disponible…',
  },
  tutorial: {
    dismiss:  'Ignorer',
    next:     'Suivant',
    done:     'Terminé',
    moreInfo: 'Plus d\'infos →',
    dontShow: 'Ne plus afficher',
  },
  awayBonus: {
    title:   'Bon retour !',
    body:    'Vous étiez absent pendant {away} et avez gagné {earned} de temps en vitesse ×2.',
    close:   'Fermer',
    watchAd: 'Regarder une pub — doubler le gain',
    continue: 'Continuer',
  },
  refillAd: {
    title:   'Stock épuisé',
    body:    'Votre stock de vitesse ×2 vient de s\'épuiser. Regardez une courte pub pour gagner 15 minutes.',
    watchAd: 'Regarder une pub — gagner 15 min',
    skip:    'Non merci',
    refill:  'remplir',
  },
  masteryCategory: {
    action: 'Action',
    damageBase: 'Dégâts de base',
    damageType: 'Type de dégâts',
    lifeMana: 'Vie & Mana',
    world: 'Monde',
  },
  masteryLabel: {
    action: 'Action',
    criticalHit: 'Coup critique',
    physical: 'Physique',
    fire: 'Feu',
    lightning: 'Foudre',
    cold: 'Froid',
    rot: 'Pourriture',
    area: 'Zone',
    projectile: 'Projectile',
    strike: 'Frappe',
    life: 'Vie',
    mana: 'Mana',
    block: 'Blocage',
    enemy: 'Ennemi',
    movement: 'Mouvement',
  },
  masteryTree: {
    action_0: 'Dégâts d\'action', action_1: 'Vitesse d\'action', action_2: 'Transe', action_3: 'Coût en mana',
    criticalHit_0: 'Dégâts critiques', criticalHit_1: 'Chance critique',
    physical_0: 'Dégâts physiques', physical_1: 'Saignement', physical_2: 'Bris de résistance', physical_3: 'Soif de sang',
    fire_0: 'Dégâts de feu', fire_1: 'Brûlure', fire_2: 'Terrain en feu', fire_3: 'Immolation',
    lightning_0: 'Dégâts de foudre', lightning_1: 'Électrocution', lightning_2: 'Saut', lightning_3: 'Électrisant',
    cold_0: 'Dégâts de froid', cold_1: 'Givre', cold_2: 'Fracas', cold_3: 'Armure de glace',
    rot_0: 'Dégâts de pourriture', rot_1: 'Poison', rot_2: 'Affaiblissement', rot_3: 'Veines vertes',
    area_0: 'Dégâts de zone', area_1: 'Taille de zone', area_2: 'Tremblement', area_3: 'Recul',
    projectile_0: 'Dégâts de projectile', projectile_1: 'Projectiles multiples', projectile_2: 'Portée de projectile', projectile_3: 'Recul',
    strike_0: 'Dégâts de frappe', strike_1: 'Frénésie', strike_2: 'Portée de frappe', strike_3: 'Cible supplémentaire',
    life_0: 'Vie maximale', life_1: 'Résistances', life_2: 'Régénération de vie', life_3: 'Vol de vie',
    mana_0: 'Mana maximum', mana_1: 'Bouclier de mana', mana_2: 'Régénération de mana', mana_3: 'Vol de mana',
    block_0: 'Chance de blocage', block_1: 'Efficacité de blocage',
    enemy_0: 'Quantité d\'ennemis', enemy_1: 'Qualité d\'ennemis', enemy_2: 'Champions et boss', enemy_3: 'Prolifération ennemie',
    movement_0: 'Vitesse de mouvement', movement_1: 'Ruée', movement_2: 'Cerf-volant',
  },
  masteryDump: {
    action: 'dégâts d\'action', criticalHit: 'dégâts de coup critique', physical: 'dégâts physiques',
    fire: 'dégâts de feu', lightning: 'dégâts de foudre', cold: 'dégâts de froid', rot: 'dégâts de pourriture', area: 'rayon d\'action de zone',
    projectile: 'portée de projectile', strike: 'vitesse d\'action de frappe', life: 'vie maximale',
    mana: 'mana maximum', enemy: 'ennemis invoqués', movement: 'vitesse de mouvement',
    block: 'chance de blocage',
  },
  runeLabel: {
    minorDmg: 'Dégâts', minorSpeed: 'Vitesse', minorMana: 'Mana', minorXp: 'Expérience', minorAll: 'Échantillon',
    majorDmg: 'Dégâts', majorSpeed: 'Vitesse', majorMana: 'Mana', majorXp: 'Expérience', majorAll: 'Échantillon',
    keySplit: 'Action divisée', keyHeavy: 'Lent & lourd', keyManaless: 'Sans mana', keyConsequences: 'Conséquences',
    sourceCold: 'Frigo ouvert', sourceFire: 'Cuisinière allumée', sourceLightning: 'Piège à insectes branché', sourcePhysical: 'Clous renversés', sourceRot: 'Chaussettes qui traînent',
  },
  runeDesc: {
    minorDmg: '+15 % de dégâts d\'action augmentés',
    minorSpeed: '+5 % de vitesse d\'action augmentée',
    minorMana: '−10 % de coût en mana d\'action',
    minorXp: '+20 % d\'expérience d\'action augmentée',
    minorAll: '+3,75 % dégâts / +1,25 % vitesse / −2,5 % coût en mana / +5 % expérience',
    majorDmg: '10 % de dégâts d\'action en plus',
    majorSpeed: '5 % de vitesse d\'action en plus',
    majorMana: '20 % moins de coût en mana d\'action',
    majorXp: '15 % d\'expérience d\'action en plus',
    majorAll: '2,5 % de dégâts en plus / 1,25 % de vitesse en plus / 5 % moins de mana / 3,75 % d\'expérience en plus',
    keySplit: '×2 vitesse d\'action — 33% de dégâts d\'action en moins',
    keyHeavy: '×2 dégâts d\'action — 33% de vitesse d\'action en moins',
    keyManaless: '×2 coût en mana — l\'action se déclenche même si le mana est insuffisant',
    keyConsequences: '×2 dégâts d\'affliction de cette action (aucun effet sur les afflictions sans dégâts)',
    sourceCold: '20% des coups comptent comme froid au lieu de la source de l\'action — les effets et l\'expérience de la maîtrise du froid s\'appliquent',
    sourceFire: '20% des coups comptent comme feu au lieu de la source de l\'action — les effets et l\'expérience de la maîtrise du feu s\'appliquent',
    sourceLightning: '20% des coups comptent comme foudre au lieu de la source de l\'action — les effets et l\'expérience de la maîtrise de la foudre s\'appliquent',
    sourcePhysical: '20% des coups comptent comme physique au lieu de la source de l\'action — les effets et l\'expérience de la maîtrise physique s\'appliquent',
    sourceRot: '20% des coups comptent comme pourriture au lieu de la source de l\'action — les effets et l\'expérience de la maîtrise de la pourriture s\'appliquent',
  },
  actionLabel: {
    sword: 'Coup d\'épée', bow: 'Flèche de sniper', fireball: 'Boule de feu', zap: 'Choc électrique',
    'fire-nova': 'Nova de feu', grenade: 'Grenade', 'hammer-slam': 'Coup de marteau',
    'lightning-nova': 'Nova de foudre', bolt: 'Éclair', 'cold-nova': 'Nova de froid', 'ice-spear': 'Lance de glace',
    'putrid-nova': 'Nova putride',
    'rotten-dagger': 'Dague pourrie',
    'poisonous-arrow': 'Flèche empoisonnée',
  },
  actionTag: {
    physical: 'physique', fire: 'feu', lightning: 'foudre', cold: 'froid', rot: 'pourriture',
    strike: 'frappe', projectile: 'projectile', area: 'zone',
  },
}
